let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a9RLt")).then(() => parcelRequire('9Vj9G'));